import React from 'react';
import { EmptyHead } from '../components';

export function EmptyHeadContainer() {
    return (
        <EmptyHead>
            
        </EmptyHead>
    )
}